module.exports = __webpack_public_path__ + "img/support.1444d29.svg";